import styled from "styled-components";

export const FlapperDefaultBox = styled.div`
    position: absolute;
    display: flex;
    /* TODO: top and left are too complicated because Flapper is not in the right container */
    /* bottom: calc(50% - 3.4% + (var(--wheels_rotating_part_width) / 2));
    left: 50% - (12%/2); */
    top: -6%;
    width: 12%;
    img {
        width: 100%;
        filter: drop-shadow(1px 3px 3px #0000007b);
    }
`